export const OFFICE_PERMISSIONS = {
  //CarrierAgreementMgmt Office
  permission_carrieragreemnentmgmt_office_view:
    "permission.carrieragreemnentmgmt.office.view",
  permission_carrieragreemnentmgmt_office_add:
    "permission.carrieragreemnentmgmt.office.add",
  permission_carrieragreemnentmgmt_office_edit:
    "permission.carrieragreemnentmgmt.office.edit",
  permission_office_franchiseoffice_edit:
    "permission.office.franchiseoffice.edit",

  //Office General Information
  permission_office_generalinformation_view:
    "permission.office.generalinformation.view",
  permission_office_generalinformation_edit:
    "permission.office.generalinformation.edit",
  permission_office_generalinformation_add:
    "permission.office.generalinformation.add",
  permission_office_generalinformation_delete:
    "permission.office.generalinformation.delete",

  //Office Hierarchy & Leadership
  permission_office_officehierarchy_view:
    "permission.office.officehierarchy.view",
  permission_office_officehierarchy_edit:
    "permission.office.officehierarchy.edit",

  //Office General Ledger Entity
  permission_office_generalledger_view: "permission.office.generalledger.view",
  permission_office_generalledger_edit: "permission.office.generalledger.edit",

  //Office Carrier Producer Codes
  permission_office_carrierproducercodes_view:
    "permission.office.carrierproducercodes.view",
  permission_office_carrierproducercodes_edit:
    "permission.office.carrierproducercodes.edit",

  //Office Employee Information
  permission_office_employeeinformation_view:
    "permission.office.employeeinformation.view",
  permission_office_employeeinformation_edit:
    "permission.office.employeeinformation.edit",

  //Office Insurance Brand
  permission_office_insurancebrand_view:
    "permission.office.insurancebrand.view",
  permission_office_insurancebrand_edit:
    "permission.office.insurancebrand.edit",

  //Office Agent of Records
  permission_office_agentofrecords_view:
    "permission.office.agentofrecords.view",
  permission_office_agentofrecords_edit:
    "permission.office.agentofrecords.edit",
  permission_office_agentofrecords_add: "permission.office.agentofrecords.add",
  permission_office_agentofrecords_delete:
    "permission.office.agentofrecords.delete",

  //Office Office Hours
  permission_office_officehours_view: "permission.office.officehours.view",
  permission_office_officehours_edit: "permission.office.officehours.edit",
  permission_office_officehours_add: "permission.office.officehours.add",

  //Office Office Address
  permission_office_address_view: "permission.office.address.view",
  permission_office_address_edit: "permission.office.address.edit",
  permission_office_address_add: "permission.office.address.add",

  //Office Dates
  permission_office_dates_view: "permission.office.dates.view",
  permission_office_dates_add: "permission.office.dates.add",
  permission_office_dates_edit: "permission.office.dates.edit",

  //Office BI&A
  permission_office_bia_view: "permission.office.bi&a.view",
  permission_office_bia_add: "permission.office.bi&a.add",
  permission_office_bia_edit: "permission.office.bi&a.edit",

  //Office Telecom
  permission_office_telecom_view: "permission.office.telecom.view",
  permission_office_telecom_add: "permission.office.telecom.add",
  permission_office_telecom_edit: "permission.office.telecom.edit",

  //Office Facilities
  permission_office_facilities_view: "permission.office.facilities.view",
  permission_office_facilities_add: "permission.office.facilities.add",
  permission_office_facilities_edit: "permission.office.facilities.edit",

  //Office Vendor Module
  permission_office_vendor_view: "permission.office.vendor.view",
  permission_office_vendor_add: "permission.office.vendor.add",
  permission_office_vendor_edit: "permission.office.vendor.edit",
  permission_office_vendor_delete: "permission.office.vendor.delete",
};

export const OFFICEFIELD_PERMISSIONS = {
  //office fields
  fieldpermission_office_officecode: "fieldpermission.office.officecode",
  fieldpermission_office_corporateofficenumber:
    "fieldpermission.office.corporateofficenumber",
  fieldpermission_office_glbranch: "fieldpermission.office.glbranch",
  fieldpermission_office_bmo: "fieldpermission.office.bmo",
  fieldpermission_office_ipAddress: "fieldpermission.office.ipaddress",
  fieldpermission_office_officedivision:
    "fieldpermission.office.officedivision",
  fieldpermission_office_accountOwner: "fieldpermission.office.accountowner",
  fieldpermission_office_bankAndAccount: "fieldpermission.office.bankaccount",
  fieldpermission_office_officedepartment:
    "fieldpermission.office.officedepartment",
  fieldpermission_office_officeimage_upload:
    "fieldpermission.office.officeimage.upload",
  fieldpermission_office_officehierarchy:
    "fieldpermission.office.officehierarchy",
};
